import { Slider } from '@material-ui/core';
import * as React from 'react';
import { ReportFieldDefinition } from "../../../../models";

interface ScaleFieldProps {
    id: string,
    value?: string,
    fieldDefinition: ReportFieldDefinition,
    readOnly?: boolean,
    invalid?: boolean,
    onChange?: (value: string) => void,
}

export const ScaleField: React.FC<ScaleFieldProps> = ({
    id,
    value,
    readOnly,
    onChange,
}) => {
    return <Slider
        id={id}
        getAriaValueText={value => value.toString()}
        value={(value && parseInt(value)) || 0}
        onChange={(_, value) => !readOnly && onChange && onChange(value?.toString() || '0')}
        step={1}
        max={10}
        valueLabelDisplay="auto"
        marks={[0,1,2,3,4,5,6,7,8,9,10].map(value => ({value, label: value.toString()}))}
    />
}